export const isTesting = !window.location.href.includes(".waboba.com");
